/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC content`)
};

const es_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido GC`)
};

const de_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Gehalt`)
};

const nl_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-gehalte`)
};

const fr_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu GC`)
};

const it_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuto GC`)
};

const pt_br2_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo GC`)
};

const pt_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo GC`)
};

const ja_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC含量`)
};

const zh_tm_gcpct_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 含量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_gcpct_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_gcpct_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_gcpct_label", locale)
	if (locale === "en") return en_tm_gcpct_label(inputs)
	if (locale === "es") return es_tm_gcpct_label(inputs)
	if (locale === "de") return de_tm_gcpct_label(inputs)
	if (locale === "nl") return nl_tm_gcpct_label(inputs)
	if (locale === "fr") return fr_tm_gcpct_label(inputs)
	if (locale === "it") return it_tm_gcpct_label(inputs)
	if (locale === "pt-BR") return pt_br2_tm_gcpct_label(inputs)
	if (locale === "pt") return pt_tm_gcpct_label(inputs)
	if (locale === "ja") return ja_tm_gcpct_label(inputs)
	return zh_tm_gcpct_label(inputs)
};